import * as cookieUtilities from './cookies.js'

/**
 * Font Utilities Module  
 * @module utilities/fonts
 * @see module:utilities/cookies
 * 
 */

/**
 * Prevent Flash of Invisible Content
 * 
 * @instance module:utilities/fonts.applyCustomFonts
 * @see module:utilities/cookies
 * @see {@link https://gomakethings.com/a-modern-font-loading-strategy-with-the-vanilla-js-fontfaceset.load-method/}
 */
export function applyCustomFonts () {

  if(!('fonts' in document)) return;

  if(cookieUtilities.get('fontsLoaded')) {
    document.documentElement.className += ' fonts-loaded'
    return
  }

  document.fonts.load('14rem Source Code Pro Regular')
  .then(document.fonts.load('14rem Inter var'))
  .then(function () {
    cookieUtilities.set('fontsLoaded', true, 7);
    document.documentElement.className += ' fonts-loaded'
  })

}
